export enum Environment {
    Dev = "Development",
    Sit = "SIT",
    AuroraSit = "AuroraSit",
    Uat = "UAT",
    Prod = "Production",
    Perf = "Perf"
}
